export const English = {
  Features: "Features",
  Blog: "Blog",
  Trade: "Trade",
  Buy: "Buy/Sell",
  Download: "Download",
  The: "The",
  gateway: "gateway",
  to: "to",
  To: "To",
  the: "the",
  next: "next",
  generation: "generation",
  of: "of",
  Gamers: "Gamers",
  Your: "Your",
  games: "games",
  coins: "coins",
  All: "All",
  in: "in",
  one: "one",
  place: "place",
  Simple: "Simple",
  fun: "fun",
  and: "and",
  And: "And",
  super: "super",
  smart: "smart",
  Scan: "Scan",
  download: "download",
  app: "app",
  Available: "Available",
  on: "on",
  assets: "assets",
  Game: "Game",
  game: "game",
  Connect: "Connect",
  thirdparty: "third-party",
  Crypto: "Crypto",
  Card: "Card",
  Authentication: "Authentication",
  Own: "Own",
  your: "your",
  earn: "earn",
  is: "is",
  Is: "Is",
  easy: "easy",
  way: "way",
  store: "store",
  manage: "manage",
  winnings: "winnings",
  Whether: "Whether",
  youre: "you're",
  Youre: "You're",
  competitive: "competitive",
  gamer: "gamer",
  or: "or",
  just: "just",
  casual: "casual",
  player: "player",
  has: "has",
  something: "something",
  for: "for",
  everyone: "everyone",
  effortlessly: "effortlessly",
  converts: "converts",
  into: "into",
  preferred: "preferred",
  cryptocurrency: "cryptocurrency",
  start: "start",
  earning: "earning",
  Exclusive: "Exclusive",
  content: "content",
  experiences: "experiences",
  now: "now",
  at: "at",
  fingertips: "fingertips",
  passport: "passport",
  unlock: "unlock",
  favourite: "favourite",
  need: "need",
  do: "do",
  connect: "connect",
  any: "any",
  other: "other",
  Gaming: "Gaming",
  Platform: "Platform",
  account: "account",
  Once: "Once",
  connected: "connected",
  youll: "you'll",
  Youll: "You'll",
  be: "be",
  able: "able",
  rewards: "rewards",
  unlocking: "unlocking",
  instantly: "instantly",
  enjoying: "enjoying",
  powered: "powered",
  by: "by",
  will: "will",
  launch: "launch",
  token: "token",
  listing: "listing",
  major: "major",
  coming: "coming",
  soon: "soon",
  participate: "participate",
  our: "our",
  premium: "premium",
  collections: "collections",
  you: "you",
  You: "You",
  must: "must",
  signup: "sign up",
  get: "get",
  verified: "verified",
  buy: "buy",
  using: "en utilisant",
  respectively: "respectively",
  Smartest: "Smartest",
  Safe: "Safe",
  Secure: "Secure",
  Earn: "Earn",
  Big: "Big",
  Join: "Join",
  Trend: "Trend",
  Dont: "Don't",
  left: "left",
  behind: "behind",
  Welcome: "Welcome",
  world: "world",
  possibilities: "possibilities",
  space: "space",
  no: "no",
  longer: "longer",
  thing: "thing",
  it: "it",
  present: "present",
  Over: "Over",
  invested: "invested",
  projects: "projects",
  past: "past",
  year: "year",
  free: "free",
  easiest: "easiest",
  anywhere: "anywhere",
  anytime: "anytime",
  Use: "Use",
  accepted: "accepted",
  from: "from",
  online: "online",
  globally: "globally",
  With: "With",
  an: "an",
  instant: "instant",
  cash: "cash",
  conversions: "conversions",
  can: "can",
  spend: "spend",
  without: "without",
  hassles: "hassles",
  top: "top",
  notch: "notch",
  security: "security",
  blockchain: "blockchain",
  backbone: "backbone",
  are: "are",
  always: "always",
  safe: "safe",
  perfect: "perfect",
  most: "most",
  out: "out",
  Rewarding: "Rewarding",
  complete: "complete",
  control: "control",
  over: "over",
  funds: "funds",
  while: "while",
  prioritizing: "prioritizing",
  gaming: "gaming",
  back: "back",
  with: "with",
  every: "every",
  use: "use",
  today: "today",
  level: "level",
  up: "up",
  rules: "rules",
  only: "only",
  keys: "keys",
  so: "so",
  Our: "Our",
  audited: "audited",
  audit: "audit",
  firms: "firms",
  constantly: "constantly",
  reviewed: "reviewed",
  ensure: "ensure",
  maximum: "maximum",
  Convenience: "Convenience",
  moment: "moment",
  WAYS: "WAYS",
  AUTHENTICATION: "AUTHENTICATION",
  TO: "TO",
  STRENGTHEN: "STRENGTHEN",
  YOUR: "YOUR",
  ASSETS: "ASSETS",
  SAFETY: "SAFETY",
  enjoy: "enjoy",
  all: "all",
  this: "this",
  amazing: "amazing",
  functionalities: "functionalities",
  A: "A",
  Decentralized: "Decentralized",
  wallet: "wallet",
  dedicated: "dedicated",
  Home: "Home",
  Marketplace: "Marketplace",
  Privacy: "Privacy",
  Policy: "Policy",
  Terms: "Terms",
  Service: "Service",
  Navigation: "Navigation",
  Products: "Products",
  Legal: "Legal",
  What: "What",
  How: "How",
  blockchains: "blockchains",
  does: "does",
  support: "support",
  types: "types",
  deposit: "deposit",
  withdrawal: "withdraw",
  earned: "earned",
  my: "my",
  I: "I",
};
